import { checkStatus } from "utils/checkStatus";
import { missionId } from "utils/urls";

const addHeaders = (options = {}) => {
  const headers = {
    "Content-Type": "application/json",
    "X-Forwarded-From": missionId,
    ...(options.headers ? options.headers : null),
  };
  return {
    ...options,
    headers,
  };
};

const customFetch = async (url, options) => {
  const response = await fetch(url, addHeaders(options));
  return checkStatus(response);
};

export default customFetch;
